import styled from 'styled-components';
import { Modal } from 'antd';

// eslint-disable-next-line import/prefer-default-export
export const MarketingFormModal = styled(Modal)`
  .ant-modal-body {
    .modal-marketing-form--container {
      display: flex;
      max-width: 100%;

      .modal-marketing-form--ad-container {
        min-width: 0;
        flex: 4;
        padding: 40px;
        max-width: 412px;
        background: #f6f8fa;
        display: none;

        .modal-marketing-form--ad-img {
          width: 100%;
          height: 100%;
          background: url(${props => props.adImage});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
      }

      .modal-marketing-form--form-container {
        min-width: 0;
        flex: 7;
      }
    }
  }

  &.demo-form-style--5 {
    width: 90% !important;
    max-width: 1196px;

    .ant-modal-body {
      .modal-marketing-form--ad-container {
        display: block;

        @media (max-width: 768px) {
          display: none;
        }
      }
    }
  }
`;
